import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'monitor';
const BASE_PATH = `${API_ROOT}/monitor`;
const PATHS = {
    LIST: BASE_PATH,
};
async function list(props) {
    const params = new URLSearchParams();
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    if (props.latitude)
        params.append('latitude', props.latitude.toString());
    if (props.longitude)
        params.append('longitude', props.longitude.toString());
    if (props.radius)
        params.append('radius', props.radius.toString());
    if (props.missionId)
        params.append('missionId', props.missionId);
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(props) {
    return props ? [CacheKey, 'list', props] : [CacheKey, 'list'];
}
export default { CacheKey, list, listKey };
